import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'shared-documentaryreview-documents-documentgroup-dialog',
    templateUrl: './shared.documentaryreview.documents.documentgroup.dialog.component.html'
})
export class SharedDocumentGroupDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private mdDialogRef: MatDialogRef<SharedDocumentGroupDialogComponent>
    ) { }

    onClose(): void {
        this.mdDialogRef.close();
    }

    onConfirm(): void {
        this.mdDialogRef.close({ documentGroup: this.data.documentGroup });
    }
}
